import '@/app/app.css';
import './public-offer.css';

import '@/app/app';
import '@/layouts/main/main.js';

window.addEventListener('DOMContentLoaded', () => {});
